// test2112
(2112 && 0);
